jQuery(document).ready(function(jQuery) {
  
  /*################### Home Pages ######################*/
  
  /* Sticky Header */
  function sticky_section() {
    
    var topbar = jQuery('.site-header .top-bar').height();
    var header = jQuery('.site-header .header-wrapper').height();
    
    //var temp = topbar + header;
    
    jQuery(window).scroll(function(){
      var sticky = jQuery('.site-header .nav-bar'),
          sticky_h_w = jQuery('.site-header .header-wrapper'),
          scroll = jQuery(window).scrollTop();

      if (scroll >= topbar){
        sticky.addClass('fixed');
        sticky_h_w.addClass('fixed');
        jQuery('body').addClass('fixed');
      }
      else {
        sticky.removeClass('fixed');
        sticky_h_w.removeClass('fixed');
        jQuery('body').removeClass('fixed');
      }
    });
  }
  sticky_section();
  jQuery(window).on('load resize orientationchange', sticky_section);
  
  
  /* Brand Collection */
  function brand_section() {
    var full_width = jQuery('body').width();
    var container = jQuery('.container').width();

    var temp_padding = full_width - container;
    var final_padding = temp_padding / 2;
    jQuery(".image_left .brand-collection-wrapper").css('padding-right', final_padding);
    jQuery(".image_right .brand-collection-wrapper").css('padding-left', final_padding);
    jQuery(".image-with-text-section .image-text-wrapper").css('padding-right', final_padding);
  }
  brand_section();
  jQuery(window).on('load resize orientationchange', brand_section);

  /* Home Section Show/Hide */
  //$(".section_men").parent(".shopify-section").hide(); 

  /* Scroll Button */
  jQuery(document).on('click', '.scroll-btn', function(event) {
    var jQueryanchor = jQuery(this);
    jQuery('html, body').stop().animate({
      scrollTop: jQuery(jQueryanchor.attr('href')).offset().top
    }, 1500, 'easeInOutExpo');
    event.preventDefault();
  });

  /* Banner Slider */ 
  jQuery('.js-banner-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed:5000,
    autoplay: true,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  /* Slick Slider */
  jQuery('.js-product-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed:5000,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false,
        }
      }
    ]
  });

  /* Brand Collection */
  jQuery('.js-brand-product-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false,
        }
      }
    ]
  });

  /* Brand Collection */
  jQuery('.js-shop-style-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed:5000,
    autoplay: false,
    centerMode: true,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        }
      }
    ]
  });

  /* Product Slider */
  jQuery('.js-product-slider-nav').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: false,
    centerMode: true,
    focusOnSelect: true,
    adaptiveHeight: false,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    rows: 0,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          focusOnSelect: true,
          adaptiveHeight: false,
        }
      }
    ]
  })
  .on('setPosition', function (event, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });

  /* Footer */
  $(".f-accordion-content").hide(); 
  $(".f-accordion-title").click(function(){
    var thisBlock = $(this).parent().index('.f-accordion-block');
    $(".f-accordion-block").find(".active").not($(this)).removeClass("active");
    $(this).toggleClass("active").next().slideToggle();
    $(this).parent().toggleClass("activeToggle").siblings()
    .removeClass("activeToggle").children(".f-accordion-content").hide();
    return false;
  });
  
  /* Mobile Search */
  jQuery(document).mouseup(function (e) {
    var menu = jQuery('.site-header .header-wrapper .mobile-left .search-mobile');
    if (!menu.is(e.target) && menu.has(e.target).length === 0){
      $(".search-mobile .search-wrapper").removeClass("active");
      //menu.removeClass('open');
    }
  });

    /*################### Product Pages ######################*/

    // color swatch js snippet
    $('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    });

  /* Product Tab */
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });

  /*################### Inner Pages ######################*/
  
  /* Accordion */ 
  $(".accordion-content").hide(); 
  $(".accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.accordion-content').slideUp();
      $('.accordion-title').not(this).removeClass('active');
      $('.accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.accordion-content').slideDown();
      $(this).parent().addClass("activeToggle"); 
    } else {
      $(this).removeClass('active');
      $(this).next('.accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 	
    }
  });

  /* Mobile Product Tabs */
  $(".p-accordion-content").hide(); 
  $(".p-accordion-title").click(function(){
    var thisBlock = $(this).parent().index('.p-accordion-block');
    $(".p-accordion-block").find(".active").not($(this)).removeClass("active");
    $(this).toggleClass("active").next().slideToggle();
    $(this).parent().toggleClass("activeToggle").siblings()
    .removeClass("activeToggle").children(".p-accordion-content").hide();
    return false;
  });
  
  /* Brand Filter */
  var triggers = $('.brand-filter a');
  var filters = $('.brand-list .brand-item .brand-name');
  
  triggers.click(function() {
    $(".all-link").removeClass('active');
    var takeLetter = $(this).text(), result = 0;
    filters.parent().hide();
	triggers.removeClass('active');
    $(this).addClass('active');
    $('#result').show();
    filters.each(function(i) {
      if ( RegExp('^'+takeLetter).test($(this).text()) ) {
        result += 1;
        $(this).parent().fadeIn(222);
      } 
    });
    $('#result').html('<p>'+(result<1 ? 'Brands not avaliable.' : result+' Brands avaliable')+'</p>');
    //if (result<1) {alert('There is no result.');}
  });
  
  $(".brand-filter .all-link").click(function(){
    $(this).addClass('active');
    filters.parent().show();
    triggers.removeClass('active');
    $('#result').hide();
  });
  
  /*################### Blog Pages ######################*/
  /* Accordion */ 
  $(".share-link").click(function(){
    $(".share_article").toggleClass('active');
  });
  
  /**/
  $('.search-link-mobile').click(function(){
  	$(".search-mobile .search-wrapper").toggleClass('active');
  });
  
  $('.blog-reult').click(function(){
  	$(".blog-tag-filter").toggleClass('active');
  });
  
  jQuery(document).mouseup(function (e) {
    var blog_result = jQuery('.blog-reult');
    if (!blog_result.is(e.target) && blog_result.has(e.target).length === 0){
      $(".blog-tag-filter").removeClass("active");
    }
  });
  
  /*################### Product Pages ######################*/ 
  /* Product Video */
  $("#ProductPhotovideo").hide();

  var video_thumb_first = $('.js-product-slider-nav .slick-current a').attr('data');
  if(video_thumb_first == 'video'){
    $("#ProductPhotovideo").show();
    $("#ProductPhotoImg").hide();
  } else {
    $("#ProductPhotovideo").hide();
    $("#ProductPhotoImg").show();
  }

  $('.js-product-slider-nav').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var video_thumb = $('.js-product-slider-nav .slick-current a').attr('data-thumbnail-id');
    $('.product-single__media-wrapper').addClass('hide');
    $('.product-single__media-wrapper[data-media-id="'+video_thumb+'"]').removeClass('hide');
//     var video_thumb = $('.js-product-slider-nav .slick-current a').attr('data');
//     if(video_thumb == 'video'){
//       $("#ProductPhotovideo").show();
//       $("#ProductPhotoImg").hide();
//     } else {
//       $("#ProductPhotovideo").hide();
//       $("#ProductPhotoImg").show();
//     }
    
  });
  var thumbs = $('#ProductThumbs').find('a.product-single__thumbnail');
  thumbs.on('click',function(e){
    e.preventDefault();
    var $el = $(this);
    var mediaId = $el.data('thumbnail-id');
    $('.product-single__media-wrapper').addClass('hide');
    $('.product-single__media-wrapper[data-media-id="'+mediaId+'"]').removeClass('hide');
  });
});